import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OmniLoaderComponent } from './omni-loader.component';



@NgModule({
    declarations: [OmniLoaderComponent],
    imports: [
        CommonModule
    ],
    exports: [
        OmniLoaderComponent
    ]
})
export class OmniLoaderModule { }
